<template>
  <div>
    <v-overlay v-model="overlay" contained class="align-center justify-center">
      <v-progress-circular color="primary" indeterminate size="140" :width="10">
      </v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
export default {
  name: "LoadingPage",
};

() => ({
  overlay: false,
});
</script>
